import React from 'react';
import PropTypes from 'prop-types';
import {
  SecondaryActionButton, Stack,
} from '@facet-wealth/design';
import {
  advisorWhatIfPageUri,
  householdSecureFilesUri,
} from 'Consts/advisorUris';
import { DataValueMap } from 'Helpers/Testing';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';
import { navigateToUriInNewTab } from 'Helpers/Navigation';
import { missionControlURL } from 'Hooks/useMissionControlURL';
import { balanceSheetPageURL } from 'Hooks/useBalanceSheetPageURL';
import useUserContext from 'Context/UserContext';

const MemberLinks = ({
  facetPlanUrl,
}) => {
  const { selectedThreadResource } = useMessagesContext();
  const { isAgent } = useUserContext();

  return (
    <Stack spacing={1} alignItems="flex-start" justifyContent="flex-start">
      <SecondaryActionButton
        label={'Mission Control'}
        size={'sm'}
        onClick={(e) => navigateToUriInNewTab(e, missionControlURL(selectedThreadResource, selectedThreadResource.attr('householdId')))}
        {...DataValueMap.init(DataValueMap.keyMap.dataResourceId, 'mission-control').build()}
      />
      <SecondaryActionButton
        label="Balance sheet"
        size={'sm'}
        onClick={(e) => navigateToUriInNewTab(e, balanceSheetPageURL(selectedThreadResource, selectedThreadResource.attr('householdId'), isAgent))}
      />
      <SecondaryActionButton
        label={'Files'}
        size={'sm'}
        onClick={(e) => navigateToUriInNewTab(e, householdSecureFilesUri(selectedThreadResource.attr('householdId')))}
      />
      {!!facetPlanUrl && (
        <SecondaryActionButton
          label={'Scenarios'}
          size={'sm'}
          onClick={(e) => {
            navigateToUriInNewTab(e, advisorWhatIfPageUri(facetPlanUrl, selectedThreadResource.attr('householdId')));
          }}
        />
      )}
    </Stack>
  );
};

MemberLinks.defaultProps = {
  facetPlanUrl: undefined,
};

MemberLinks.propTypes = {
  facetPlanUrl: PropTypes.string,
};

export { MemberLinks };
